import React, { useState } from "react";

import PlacesAutocomplete from "react-places-autocomplete";
import { updateAppData } from "../../utils/actionUtils";
import { ApplicationInputStyle } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { Box, ClickAwayListener, Stack } from "@mui/material";
import { OptionsPanel } from "../FettiAutocomplete";
import FettiChip from "../FettiChip";
import FettiInput from "../FettiInput";

const field = "location";
const ApplyLocationAutocomplete = () => {
  const dispatch = useDispatch();
  const appData = useSelector((state) => state.apply.app);
  const [address, setAddress] = React.useState("");
  const [focused, setFocused] = useState(false);
  const handleSelectOption = (v) => {
    setAddress("");
    setFocused(false);
    updateAppData(dispatch, {
      [field]: v,
    });
  };
  return (
    <PlacesAutocomplete
      value={address}
      onChange={setAddress}
      searchOptions={{
        types: ["(cities)"],
      }}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <Stack
          {...ApplicationInputStyle.stackProps}
          sx={ApplicationInputStyle.stack}>
          <Box sx={ApplicationInputStyle.header}>
            Location{" "}
            <span style={ApplicationInputStyle.optional}>(optional)</span>
          </Box>
          {appData[field] && (
            <FettiChip
              value={appData[field]}
              onClick={() => {
                updateAppData(dispatch, {
                  [field]: "",
                });
              }}
            />
          )}
          {!appData[field] && (
            <ClickAwayListener onClickAway={() => setFocused(false)}>
              <Box sx={{ width: "100%", position: "relative" }}>
                <FettiInput
                  onFocus={() => {
                    setFocused(true);
                  }}
                  {...getInputProps({
                    placeholder: "Search locations (e.g. New York)",
                    className: "location-search-input",
                  })}
                  onBlur={() => {
                    // do nothing; needed to prevent the options panel from closing (by PlacesAutocomplete default behavior) when clicking on an option
                  }}
                />
                <OptionsPanel
                  open={focused && suggestions.length > 0}
                  options={suggestions.map((s) =>
                    s.description.replace(", USA", "")
                  )}
                  setValue={handleSelectOption}
                />
              </Box>
            </ClickAwayListener>
          )}
        </Stack>
      )}
    </PlacesAutocomplete>
  );
};

export default ApplyLocationAutocomplete;
